import React from "react";
import JsonFormRenderValue from "./JsonFormRenderValue";
export default function JsonformTableRender({ form, data = {} }) {
  if (!Array.isArray(form)) return null;
  return (
    <table className="table jsonform-table">
      <tbody>
        {form.map((field, idx) => {
          if (!field) return null;

          let value = data[field.key];
          if (Array.isArray(field.subform) && Array.isArray(value)) {
            return (
              <tr key={idx}>
                <td colSpan={2}>
                  <table className="table">
                    <thead>
                      <tr>
                        <td colSpan={99}>{field.label}</td>
                      </tr>
                      <tr>
                        {field.subform.map((f, idx) => (
                          <th key={idx}>{f.label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {value.map((dataRow, idx) => {
                        return (
                          <tr key={idx}>
                            {field.subform.map((f, idx) => (
                              <td key={idx}>
                                <JsonFormRenderValue
                                  field={f}
                                  value={dataRow[f.key]}
                                />
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
              </tr>
            );
          } else {
            return (
              <tr key={idx}>
                <td>{field.label}</td>
                <td>
                  <JsonFormRenderValue field={field} value={value} />
                </td>
              </tr>
            );
          }
        })}

        <tr></tr>
      </tbody>
    </table>
  );
}
